import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";

import "./Buttons.css";

function BtnClear({ size, onClick, isClicked, label }) {
  return (
    <Col className="p-1">
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#fff" />
        </Button>
      ) : (
        <Button className="action-btn clear" size={size} onClick={onClick}>
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnClear;
